import { ICheckServiceResponseError } from '../../../repositories/billing-tariffs/v3/check-service';
import { ECheckServiceErrorCode } from '../../../types/reducers/checkoutInfo';

export const hasTokenError = (errors: ICheckServiceResponseError['errors']) => {
  return errors.some(error => error.code === ECheckServiceErrorCode.tokenExpired);
};
